import type { PlayerRef } from "@catbento/shared";

// A sensible default player, seeded into a fresh needs-player widget so a dropped
// card shows real data immediately instead of an empty "search a player" state
// (the prototype does this for free from static data; we do it with one live
// fetch on mount). Used only when there's no sticky last-used player yet.
//
// Rodri (Barcelona) for now — Prateek's pick; revisit with the team. Concrete ids
// because the app doesn't yet resolve most-recent comp/season from a bare id.
export const DEFAULT_PLAYER: PlayerRef = {
  playerId: 6765,
  competitionId: 11,
  seasonId: 52026,
  displayName: "Rodrigo Hernández Cascante",
};
